// frontend/src/pages/Login.jsx
// commit: fix(auth): correct trialExpired check to match api.js throw shape

import { useState }    from 'react';
import { useNavigate } from 'react-router-dom';
import api             from '../api';

export default function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const [loading, setLoading]   = useState(false);
  const navigate                = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.user);
    } catch (err) {
      // api.js request() throws a plain object: { message, trialExpired }
      // NOT an Axios-shaped error — do not check err.response?.data
      if (err.trialExpired) {
        navigate('/upgrade');
        return;
      }
      setError(err.message || 'Login failed — check your email and password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand-mark">FAG</div>
          <h1>AI Governance Platform</h1>
          <p>Flow Advisory Group</p>
        </div>

        {error && <div className="form-error" style={{ marginBottom: '14px' }}>{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
              placeholder="you@yourorg.com.au"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </label>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="login-footer">
          APRA-regulated AI governance · Data hosted in Australia
        </p>
      </div>
    </div>
  );
}
